import { combineReducers } from "redux";
import authReducer from "./authReducer";
import commonReducer from "./commonReducer";
import onBoardingReducer from "./onBoardingReducer";

export default combineReducers({ authReducer, commonReducer, onBoardingReducer });
